// extracted by mini-css-extract-plugin
module.exports = {"classFour":"Table_classFour__2A0c7"};